import React from 'react';
import {Redirect} from 'react-router-dom';
import {FuseLoadable} from '@fuse';

export const ScrumboardAppConfig = {
    settings: {
        layout: {}
    },
    routes  : [
        {
            path     : '/app/rPRec/rPRecKa/:boardId',
            component: FuseLoadable({
                loader: () => import('./board/Board')
            })
        },
        {
            path     : '/app/rPRec/rPRecKa',
            // component: FuseLoadable({
            //     loader: () => import('./boards/Boards')
            // })
            component: () => <Redirect to="/app/rPRec/rPRecKa/1"/>


        },
        {
            path     : '/apps/scrumboard',
            component: () => <Redirect to="/apps/scrumboard/boards"/>
        }
    ]
};
